// This icon file is generated automatically.
var PLockOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11 5.25H9.94v-3.5a2 2 0 00-2-2H4.06a2 2 0 00-2 2v3.5H1a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h10a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zm-7.81-3.5c0-.48.39-.88.87-.88h3.88c.48 0 .87.4.87.88v3.5H3.2v-3.5zm7.19 9.38H1.62V6.37h8.75v4.75zM5.55 8.95v.83c0 .07.06.13.13.13h.62c.07 0 .13-.06.13-.13v-.83a.75.75 0 10-.88 0z", "fill-rule": "nonzero" } }] }, "name": "p-lock", "theme": "outlined" };
export default PLockOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLockOutlined.js
// module id = 3499
// module chunks = 0